var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState, useMemo } from 'react';
import api from '@utils/axios';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import { gocanvasFormsPath, gocanvasFormPath } from '../../../../routes';
function useGocanvasForms(searchText) {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const sortByDisplayName = (list) => [...list].sort((a, b) => a.displayName.localeCompare(b.displayName, undefined, { sensitivity: 'base' }));
    const fetchForms = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const res = yield api.get(gocanvasFormsPath({ format: 'json' }));
            const data = res.data.gocanvasForms;
            setForms(sortByDisplayName(data));
        }
        finally {
            setLoading(false);
        }
    });
    useEffect(() => {
        fetchForms();
    }, []);
    const updateGocanvasForm = (form) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.patch(gocanvasFormPath(form.id), {
                gocanvas_form: {
                    display_name: form.displayName
                }
            });
            setForms((prev) => sortByDisplayName(prev.map((f) => f.id === form.id ? Object.assign(Object.assign({}, f), { displayName: form.displayName }) : f)));
            toast.success(translate('detail.update_success', { namespace }));
            return true;
        }
        catch (e) {
            toast.error(translate('detail.update_failure', { namespace }));
            return false;
        }
    });
    const addGocanvasForm = (form) => {
        setForms((prev) => sortByDisplayName([...prev, form]));
    };
    const filteredForms = useMemo(() => {
        if (!searchText.trim())
            return forms;
        const lower = searchText.toLowerCase();
        return forms.filter(({ displayName, template }) => [displayName, template === null || template === void 0 ? void 0 : template.country, template === null || template === void 0 ? void 0 : template.state, template === null || template === void 0 ? void 0 : template.city].some((field) => field === null || field === void 0 ? void 0 : field.toLowerCase().includes(lower)));
    }, [searchText, forms]);
    return {
        forms: filteredForms,
        loading,
        updateGocanvasForm,
        addGocanvasForm
    };
}
export default useGocanvasForms;
